import { FlagCategoryEnum } from '@/features/flag/types/flagCategory';

export const flagGermanLocalization = {
  categories: {
    [FlagCategoryEnum.CopyrightInfringement]: 'Verletzung des Urheberrechts',
    [FlagCategoryEnum.HateSpeech]: 'Hassrede & Diskriminierung',
    [FlagCategoryEnum.Pornography]: 'Pornographische Inhalte',
    [FlagCategoryEnum.Spam]: 'Spam & Werbung',
    [FlagCategoryEnum.Other]: 'Sonstiges'
  },
  title: 'Verstoß melden',
  subtitle: "Etwas passt hier nicht?\nSag's uns, wir schauen hin!",
  kind: 'Art des Verstoßes',
  description: 'Beschreibung',
  optional: ' (optional)',
  descriptionHint: 'Beschreibe den Verstoß',
  send: 'Absenden',
  toast: 'Vielen Dank für deine Hilfe!\nWir schauen uns das umgehend an.',
  accessibility: {
    editorHint: 'Beschreibe den Verstoß',
    editorLabel: 'Verstoß-Beschreibung',
    dropdownHint: 'Dropdown für Kategorie öffnen',
    dropdownLabel: 'Kategorie-Dropdown'
  }
};

type FlagsLocalization = typeof flagGermanLocalization;

export const flagEnglishLocalization: FlagsLocalization = {
  categories: {
    [FlagCategoryEnum.CopyrightInfringement]: 'Copyright infringement',
    [FlagCategoryEnum.HateSpeech]: 'Hate speech & discrimination ',
    [FlagCategoryEnum.Pornography]: 'Pornographic contents',
    [FlagCategoryEnum.Spam]: 'Spam & advertisement',
    [FlagCategoryEnum.Other]: 'Other'
  },
  title: 'Report violation',
  subtitle: "Something isn't right here?\nTell us, we'll check it out!",
  kind: 'Type of violation',
  description: 'Description',
  optional: ' (optional)',
  descriptionHint: 'Describe the violation',
  send: 'Submit',
  toast: "Thank you for your help!\nWe'll check it out.",
  accessibility: {
    editorHint: 'Describe the violation',
    editorLabel: 'Violation description',
    dropdownHint: 'Open dropdown for category',
    dropdownLabel: 'Category dropdown'
  }
};
